import * as React from 'react';
import { CardBlock } from './CardBlock';
import { FlexContainer } from '../Container';
import { ICards } from '../../models/content.interfaces';

export const CardBlockContainer = ({
  items = [],
  trackingPrefix,
  Component = CardBlock,
  showAnimations,
}: ICards) => {
  return (
    <FlexContainer>
      {items
        .filter(({ headline }) => headline != null && headline.length)
        .map((card, ix, { length }) => (
          <Component
            key={ix + card.headline}
            header={card.headline}
            byline={card.bylineHtml}
            image={card.image}
            iconSvg={card.iconSvg}
            twoColumns={length === 2}
            link={card.buttonUrl}
            trackingPrefix={trackingPrefix}
            showAnimations={showAnimations}
            index={ix}
          />
        ))}
    </FlexContainer>
  );
};
